import * as React from "react";
function SvgBubblePress(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path d="M8.5 26A2.5 2.5 0 016 23.5v-5A2.5 2.5 0 018.5 16h1.25V7.88A1.88 1.88 0 0111.62 6h12.5A1.88 1.88 0 0126 7.88V23.5a2.5 2.5 0 01-2.5 2.5zm2.17-1.25H23.5a1.25 1.25 0 001.25-1.25V7.88a.63.63 0 00-.63-.63h-12.5a.63.63 0 00-.62.63V23.5a2.51 2.51 0 01-.33 1.25zM17.88 11h-3.76a.63.63 0 010-1.25h3.76a.63.63 0 010 1.25zm3.74 3.75h-7.5a.63.63 0 010-1.25h7.5a.63.63 0 110 1.25zm0 3.75h-7.5a.63.63 0 010-1.25h7.5a.63.63 0 110 1.25zM8.5 17.25a1.25 1.25 0 00-1.25 1.25v5a1.25 1.25 0 002.5 0v-6.25z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgBubblePress);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
